import { NoticeInt } from "@interfaces/";
type NoticeDestinations = 'GUA' | 'CAN' | 'USA'
export class Notices {
  static elements: NoticeModel[] = [];
  static findNotice(notice: string, language: string): NoticeModel {
    if(this.getNotices().length === 0){
      return new NoticeModel();
    }
    return this.getNotices().find(
      (res: NoticeModel) => {
        return res.destination === notice && res.language === (language== "zh_CN"? "zh_CH":language)
      })!;
  }

  static setNotices(notices: NoticeModel[]) {
    this.elements = notices;
  }

  static getNotices(): NoticeModel[]{
    return this.elements;
  }
}

export class NoticeModel implements NoticeInt {
  status: string;
  titleNode: string;
  language: string;
  destination: string;
  image: string;
  constructor (
    notice?: NoticeInt
  ) {
    if ( notice ) {
      this.status = notice.status;
      this.titleNode = notice.titleNode;
      this.language = notice.language;
      this.destination = notice.destination;
      this.image = notice.image;
    }
  }

}
